// extracted by mini-css-extract-plugin
module.exports = {"button":"NewGameButton_button_36uA1","icon-ghost":"NewGameButton_icon-ghost_s7Anz","icon-play":"NewGameButton_icon-play_2AWzd","button-icon":"NewGameButton_button-icon_13C7R"};